<div class="outlet-content">
  <button
    class="supplierAndOutletBtn"
    [ngClass]="{ newOutlet: outlet.outletId === -1 }"
    mat-button
  >
    <div
      class="buttonText"
      [ngClass]="{ buttonTextNewOutlet: outlet.outletId === -1 }"
    >
      {{ outlet.outletName }}
    </div>
    <div class="buttonText supplierOutletDeliveryAddress">
      {{ outlet.address }}
    </div>
  </button>
  <div class="info">
    <i class="icon-font icon-Info"></i>
    <div class="info-text">
      {{ 'info_text_code_activation' | translate }}
    </div>
  </div>
  <div class="wrap-form-code">
    <app-activate-code-form #form></app-activate-code-form>
  </div>
</div>
<footer
  [ngClass]="{
    'footer-filter-desktop': !mobile,
    'footer-filter d-flex': mobile
  }"
>
  <button
    [ngClass]="{
      'full-width b2b-button link-button': mobile
    }"
    mat-flat-button
    (click)="goPrevClick()"
    [disabled]="loading"
  >
    {{ 'back' | translate }}
  </button>

  <button
    [ngClass]="{
      'primary-button': !mobile,
      'full-width b2b-button active-button': mobile
    }"
    mat-flat-button
    (click)="sendActivationCode()"
    [disabled]="loading || form.formActivateCatalog.invalid"
  >
    {{ 'go' | translate }}
    <mat-spinner
      *ngIf="loading"
      [diameter]="20"
      [strokeWidth]="2"
      [ngStyle]="{ display: 'inline-block' }"
    ></mat-spinner>
  </button>
</footer>
